import React from 'react';
import clsx from 'clsx';

import magnifyChart from '../images/magnify-chart.svg';
import downCaret from '../images/caret-down.svg';
import './TopbarCategory.scss';

function TopbarCategory(props) {
    const isActiveCategory = props.activeView !== null && props.activeView.categoryName === props.name;

    return (
        <>
            <button
                type="button"
                className={clsx("btn link w-100 d-flex align-items-center topbar-category mt-5",
                    isActiveCategory && "active")}
                onClick={props.open}
                aria-expanded={props.isOpen}
                aria-controls={`${props.name}-nav`}>
                <img
                    src={magnifyChart}
                    alt={props.name}
                    className="category mr-2" />
                {` ${props.name} `}
                <img
                    src={downCaret}
                    alt="Open/Close Category"
                    className="caret ml-auto" />
            </button>
            <ul
                id={`${props.name}-nav`}
                className={clsx("topbar-views w-100 d-flex flex-column",
                    !props.isOpen && "hidden")}
                aria-hidden={!props.isOpen}>
                {props.views.map((view) =>
                    <li className="nav-item w-100" key={view.viewName}>
                        <button
                            className={clsx("btn link nav-link w-100",
                                isActiveCategory && props.activeView.displayName === view.displayName && "active")}
                            tabIndex={props.isOpen ? 0 : -1}
                            onClick={() => props.setActiveView(view)}>
                            {view.displayName}
                        </button>
                    </li>
                )}
            </ul>
        </>
    );
}

export default TopbarCategory;